import React from 'react';
import {
  mergeClasses, useArrowNavigationGroup,
} from '@fluentui/react-components';

import { Theme } from './types';
import { ThemeCell } from './ThemeCell';
import { useThemeGridStyles } from './useThemesGridStyles.styles';

export interface ThemesGridProps {
  disabled?: boolean;
  themes: Theme[];
  themeCount?: number;
  onSelectTheme: (index: number) => void;
}

export const ThemesGrid: React.FC<ThemesGridProps> = (props) => {
  const {
    disabled,
    onSelectTheme,
    themeCount,
    themes,
  } = props;
  const classes = useThemeGridStyles();

  const themesToDisplay = themes.slice(0, themeCount);
  const navigationProps = useArrowNavigationGroup({ axis: 'grid', memorizeCurrent: true });

  return (
    <div
      className={mergeClasses('recommended-themes-grid', classes.root)}
      role="list"
      {...navigationProps}
    >
      {themesToDisplay.map((theme, index) => (
        <div
          key={theme.RecommendationId}
          role="listitem"
          className={mergeClasses('recommended-themes-cell', classes.cell)}
        >
          <ThemeCell
            disabled={disabled}
            theme={theme}
            onSelect={() => onSelectTheme(index)}
          />
        </div>
      ))}
    </div>
  );
};

ThemesGrid.defaultProps = {
  themeCount: 4,
};
